type BingEventNames = 'free trial started' | 'page_view';

export const bingTrackEvent = (
  eventName: BingEventNames,
  data: Record<string, unknown> = {},
) => {
  window['uetq'] = window['uetq'] || [];
  window['uetq'].push('event', eventName, data);
};

export const fireBingPageView = () => {
  bingTrackEvent('page_view', {
    page_path: window.location.pathname,
  });
};
